import { Button } from '@/components/ui/button';
import { useAuthService } from '@/services/authService';
import { LogOut } from 'lucide-react';
import { useState } from 'react';

interface LogoutButtonProps {
  variant?: 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link';
  size?: 'default' | 'sm' | 'lg' | 'icon';
  showIcon?: boolean;
  className?: string;
}

export function LogoutButton({
  variant = 'ghost',
  size = 'default',
  showIcon = true,
  className = '',
}: LogoutButtonProps) {
  const { logout } = useAuthService();
  const [isLoading, setIsLoading] = useState(false);

  const handleLogout = async () => {
    setIsLoading(true);
    try {
      await logout();
    } catch (error) {
      console.error('Logout failed in component:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      data-testid="logout-button"
      variant={variant}
      size={size}
      onClick={handleLogout}
      disabled={isLoading}
      className={className}
    >
      {showIcon && <LogOut className="mr-2 h-4 w-4" />}
      {isLoading ? 'Logging out...' : 'Logout'}
    </Button>
  );
}
